// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanOmniBalanceHistoryDto
 */
export interface IPlanOmniBalanceHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanOmniBalanceHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanOmniBalanceHistoryDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanOmniBalanceHistoryDto
     */
    available_balance?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPlanOmniBalanceHistoryDto
     */
    date?: Date;
}

/**
 * Check if a given object implements the IPlanOmniBalanceHistoryDto interface.
 */
export function instanceOfIPlanOmniBalanceHistoryDto(value: object): value is IPlanOmniBalanceHistoryDto {
    return true;
}

export function IPlanOmniBalanceHistoryDtoFromJSON(json: any): IPlanOmniBalanceHistoryDto {
    return IPlanOmniBalanceHistoryDtoFromJSONTyped(json, false);
}

export function IPlanOmniBalanceHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanOmniBalanceHistoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}

export function IPlanOmniBalanceHistoryDtoToJSON(json: any): IPlanOmniBalanceHistoryDto {
    return IPlanOmniBalanceHistoryDtoToJSONTyped(json, false);
}

export function IPlanOmniBalanceHistoryDtoToJSONTyped(value?: IPlanOmniBalanceHistoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account_id': value['account_id'],
        'available_balance': value['available_balance'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0,10)),
    };
}

